import { render, staticRenderFns } from "./invoice-form.vue?vue&type=template&id=52655e86&"
import script from "./invoice-form.ts?vue&type=script&lang=ts&"
export * from "./invoice-form.ts?vue&type=script&lang=ts&"
import style0 from "./invoice-form.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports